import Link from "next/link";

// lib
import { cn } from "@/lib/utils";
import Image from "next/image";

type SocialType = {
  name: string;
  link: string;
};

export const SocialShare1 = (item: SocialType, className?: string) => {
  switch (item.name) {
    case "ig":
      return (
        <Link
          href={item.link}
          target="_blank"
          key={item.link}
          className={cn("relative z-10 group flex items-center justify-center transition-transform hover:scale-110 duration-300", className)}
        >
          <Image
            src={`/assets/imgs/icon/socialmedia/yt-icon.svg`}
            width={24}
            height={24}
            alt={item.name}
            className="h-5 w-5 md:h-[22px] md:w-[22px] object-contain opacity-100 lg:opacity-70 group-hover:opacity-100 transition-opacity duration-300"
          />
        </Link>
      );
    case "x":
      return (
        <Link
          href={item.link}
          target="_blank"
          key={item.link}
          className={cn("relative z-10 group flex items-center justify-center transition-transform hover:scale-110 duration-300", className)}
        >
          <Image
            src={`/assets/imgs/icon/socialmedia/x-icon.svg`}
            width={24}
            height={24}
            alt={item.name}
            className="h-5 w-5 md:h-[22px] md:w-[22px] object-contain opacity-100 lg:opacity-70 group-hover:opacity-100 transition-opacity duration-300"
          />
        </Link>
      );
    case "yt":
      return (
        <Link
          href={item.link}
          target="_blank"
          key={item.link}
          className={cn("relative z-10 group flex items-center justify-center transition-transform hover:scale-110 duration-300", className)}
        >
          <Image
            src={`/assets/imgs/icon/socialmedia/yt-icon.svg`}
            width={24}
            height={24}
            alt={item.name}
            className="h-5 w-5 md:h-[22px] md:w-[22px] object-contain opacity-100 lg:opacity-70 group-hover:opacity-100 transition-opacity duration-300"
          />
        </Link>
      );
  }
};
